import React from "react";

const SearchIcon = () => {
    return (
        <svg className="fill-current"  viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd"
                d="M14.2583 13.6666H14.9167L18.45 17.2166C18.7917 17.5583 18.7917 18.1166 18.45 18.4583C18.1083 18.8 17.55 18.8 17.2083 18.4583L13.6667 14.9166V14.2583L13.4417 14.025C12.275 15.025 10.6833 15.5416 8.99167 15.2583C6.675 14.8666 4.825 12.9333 4.54167 10.6C4.10834 7.07497 7.075 4.10831 10.6 4.54164C12.9333 4.82497 14.8667 6.67497 15.2583 8.99164C15.5417 10.6833 15.025 12.275 14.025 13.4416L14.2583 13.6666ZM6.16667 9.91664C6.16667 11.9916 7.84167 13.6666 9.91667 13.6666C11.9917 13.6666 13.6667 11.9916 13.6667 9.91664C13.6667 7.84164 11.9917 6.16664 9.91667 6.16664C7.84167 6.16664 6.16667 7.84164 6.16667 9.91664Z" />
        </svg>
    );
};

export default SearchIcon;
